module.exports = __webpack_public_path__ + "static/media/spoonerism-task (5).cbaa6068.mp3";